import React, { FC } from 'react';

import { EvSvgIcon, X } from '@evinced-private/ui-common';

import './RemoveIconButton.scss';

interface RemoveIconButtonProps {
	onClick: () => void;
	ariaLabel: string;
	className?: string;
}

export const RemoveIconButton: FC<RemoveIconButtonProps> = ({
	onClick,
	ariaLabel,
	className = ''
}) => {
	return (
		<button
			type="button"
			className={`remove-icon-button ${className}`}
			onClick={onClick}
			aria-label={ariaLabel}
		>
			<EvSvgIcon icon={X} isSmall />
		</button>
	);
};
